import { ErrorMessage, Field, FieldProps, useFormikContext } from "formik";
import { Checkbox, CheckboxProps } from "primereact/checkbox";
import styled from "styled-components";
import { concatClassnames } from "../../../utils/style/concatClassnames";
import { SPField } from "./sharedStyles";
import React from "react";
import { Modify } from "../../../utils/TypeScriptUtils";

type SPFormikCheckboxProps = Modify<
  CheckboxProps,
  {
    label: string;
    name: string;
    onChange?: (e: any, form: any) => void;
    required?: boolean;
    checked?: boolean;
    checkboxRight?: boolean;
    showErrorMessage?: boolean;
  }
>;

export const SPFormikCheckbox = (props: SPFormikCheckboxProps) => {
  const {
    label,
    disabled,
    name,
    onChange,
    value,
    required,
    checkboxRight,
    showErrorMessage = true,
    ...rest
  } = props;

  const { handleBlur } = useFormikContext();

  return (
    <SPField
      className={concatClassnames([
        "sp-formik-input-text-container",
        disabled && "spfield--disabled",
      ])}
    >
      <Field name={name}>
        {(props: FieldProps<SPFormikCheckboxProps["value"]>) => {
          const { field, form, meta } = props;

          return (
            <StyledContainer className="sp-formik-checkbox-container">
              <div
                className={concatClassnames([
                  "sp-formik-checkbox-container__inner",
                  checkboxRight && "checkbox-right",
                ])}
              >
                <Checkbox
                  inputId={name}
                  {...field}
                  {...rest}
                  checked={!!field.value}
                  disabled={disabled}
                  onChange={(e) => {
                    if (onChange) {
                      onChange(e, form);
                    } else {
                      field.onChange(e);
                    }
                  }}
                  onBlur={() => handleBlur({ target: { name } })}
                />
                <label
                  style={{
                    marginRight: checkboxRight ? "0.5rem" : "0",
                    marginLeft: checkboxRight ? "0" : "0.5rem",
                  }}
                  htmlFor={name}
                >
                  {label}
                  {!!required && <span className="required">*</span>}
                </label>
              </div>
              {!!showErrorMessage && (
                <div className="input-error-container">
                  <ErrorMessage
                    className="input-error-container__error-msg"
                    component="div"
                    name={name}
                  />
                </div>
              )}
            </StyledContainer>
          );
        }}
      </Field>
    </SPField>
  );
};

const StyledContainer = styled.div`
  .sp-formik-checkbox-container__inner {
    display: flex;
    align-items: center;

    label {
      cursor: pointer;
    }

    &.checkbox-right {
      flex-direction: row-reverse;
      align-items: center;
    }
  }
`;
